<div class="">
    <!-- <div class="sectionlabel">Entertainment Schedule</div> -->
    <div class="tenpxtop"></div>
    <div class="entertainmentarea">
        <div class="entertainmentrows" *ngFor="let entertainmenttime of EntertainmenttimesInfo; let i=index;">
            <div class="entertainmentdate"
                *ngIf="EntertainmenttimesInfo!=undefined && (i==0 || EntertainmenttimesInfo[i].aiiDate !=EntertainmenttimesInfo[i-1].aiiDate)">
                {{entertainmenttime.aiiDate | date:'fullDate'}}</div>
            <div class="entertainmentarearow row">
                <div class="col-1"></div>
                <div class="col-10">
                    <div class="entertainment"> <span class="entlink"
                            (click)="showbio(entertainmenttime)">{{entertainmenttime.aiiActivityName}}</span></div>
                    <div class="entertainmenttimelocation ">
                        <span class="entertainmenttime"> {{entertainmenttime.aiibegtime | timepipe}} -
                            {{entertainmenttime.aiiendtime |
                            timepipe}}</span> <span> | </span><span class="entertainmentlocation"><a
                                [routerLink]="['/shiplocation', entertainmenttime.dplDeck]">{{entertainmenttime.slnName}}</a></span>
                    </div>
                </div>
                <div class="tenpxtop"></div>
            </div>

        </div>

    </div>
</div>